import type { GameId } from '@gmp/shared-types/browser';
import type { GameMeta } from '@gmp/game-sdk';
import { panicButtonMeta } from '@gmp/panic-button/meta';
import { snapScrambleMeta } from '@gmp/snapscramble/meta';
import { actOfNonsenseMeta } from '@gmp/act-of-nonsense/meta';
import { waveCommandMeta } from '@gmp/wave-command/meta';
import { mercenaryMarketMeta } from '@gmp/mercenary-market/meta';
import { orbHavocMeta } from '@gmp/orb-havoc/meta';
import { battleBotsMeta } from '@gmp/battle-bots/meta';
import { meteorMayhemMeta } from '@gmp/meteor-mayhem/meta';
import { lavaRisingMeta } from '@gmp/lava-rising/meta';
import { objectionMeta } from '@gmp/objection/meta';
import { filibusterMeta } from '@gmp/filibuster/meta';
import { dealbreakersMeta } from '@gmp/dealbreakers/meta';

/** Game metadata for menus. Rules and content are never loaded in the browser. */
export const CATALOG: GameMeta[] = [panicButtonMeta, snapScrambleMeta, actOfNonsenseMeta, waveCommandMeta, mercenaryMarketMeta, orbHavocMeta, battleBotsMeta, meteorMayhemMeta, lavaRisingMeta, objectionMeta, filibusterMeta, dealbreakersMeta, doubleAgentMeta, theAlibiMeta, conspiracyClubMeta, terribleAdviceMeta, plotTwistMeta, rottenReviewsMeta, humanResourcesMeta, boulderBashMeta, pizzaHeistMeta, recessRumbleMeta, misquotedMeta, initialReactionMeta, starStruckMeta, grudgeGauntletMeta, phonenanigansMeta];
import { doubleAgentMeta } from '@gmp/double-agent/meta';
import { theAlibiMeta } from '@gmp/the-alibi/meta';
import { conspiracyClubMeta } from '@gmp/conspiracy-club/meta';
import { terribleAdviceMeta } from '@gmp/terrible-advice/meta';
import { plotTwistMeta } from '@gmp/plot-twist/meta';
import { rottenReviewsMeta } from '@gmp/rotten-reviews/meta';
import { humanResourcesMeta } from '@gmp/human-resources/meta';
import { boulderBashMeta } from '@gmp/boulder-bash/meta';
import { pizzaHeistMeta } from '@gmp/pizza-heist/meta';
import { recessRumbleMeta } from '@gmp/recess-rumble/meta';
import { misquotedMeta } from '@gmp/misquoted/meta';
import { initialReactionMeta } from '@gmp/initial-reaction/meta';
import { starStruckMeta } from '@gmp/star-struck/meta';
import { grudgeGauntletMeta } from '@gmp/grudge-gauntlet/meta';
import { phonenanigansMeta } from '@gmp/phonenanigans/meta';
export const gameInfo = (id: GameId) => CATALOG.find((g) => g.id === id)!;
